var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8703 23.8756V23.8748H24.8748V17.3192C24.8748 14.1121 24.1843 11.6416 20.435 11.6416C18.6326 11.6416 17.4231 12.6307 16.9293 13.5684H16.8772V11.941H13.3223V23.8748H17.0239V17.9656C17.0239 16.4098 17.3188 14.9053 19.2456 14.9053C21.1441 14.9053 21.1724 16.6809 21.1724 18.0654V23.8756H24.8703Z",
    fill: "#00A988"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29492 11.9414H11.001V23.8752H7.29492V11.9414Z",
    fill: "#00A988"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1465 6C7.96153 6 7 6.96153 7 8.1465C7 9.33146 7.96153 10.3131 9.1465 10.3131C10.3315 10.3131 11.293 9.33146 11.293 8.1465C11.2922 6.96153 10.3307 6 9.1465 6V6Z",
    fill: "#00A988"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.3606094a201ecdf84058d8049bc53a28.svg";
export { ForwardRef as ReactComponent };